import React, { useEffect, useState } from "react";
// componentes
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  Row,
  Button,
  Collapse,
  Spinner,
} from "reactstrap";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../components/SearchFilters";
import ModalNewStock from "./ModalNewStock";
import ModalEditStock from "./ModalEditStock";
import ModalConfig from "./ModalConfig";
import ModalAllImports from "./ModalAllImports";
import ModalLinksEmbeded from "./ModalLinkEmbeded";
import Pagination from "../../../components/Paginationv3";
import SweetAlert from "react-bootstrap-sweetalert";
import WaitExport from "../../../components/WaitExport";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
// alerta
import { toast } from "react-toastify";
// redux
import { connect } from "react-redux";
// rotas
import { useLocation } from "react-router-dom";
// services
import {
  deleteStockActivity,
  deleteAll,
  getStockActivities,
} from "../../../utils/services/schedulingAndStock";
// utils
import moment from "moment";
import { createStockXlsx } from "./createXlsx";
import useDebounce from "../../../utils/hooks/useDebounce";

function Stock(props) {
  const location = useLocation();
  const token = props.state.global_user_data.data.token;

  // id do evento
  const idEvent = location.state.idEvent;

  // state de busca e filtros
  const [search, setSearch] = useState("");
  const [activeFilter, setActiveFilter] = useState("sala");
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const debouncedSearch = useDebounce(search, 300);

  // state de dados da tabela
  const [activities, setActivities] = useState([]);
  const [activitiesEdit, setActivitiesEdit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // state de paginação
  const [countData, setCountData] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // state de modais
  const [modalNewStock, setModalNewStock] = useState(false);
  const [modalEditStock, setModalEditStock] = useState(false);
  const [modalConfig, setModalConfig] = useState(false);
  const [modalImport, setModalImport] = useState(false);
  const [modalLink, setModalLink] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);

  // state de exclusão
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [confirmAllDisabled, setConfirmAllDisabled] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [errorOnDeleteAll, setErrorOnDeleteAll] = useState(false);

  // state de alertas (SweetAlert)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDeleteErrorAlert, setShowDeleteErrorAlert] = useState(false);
  const [successDlg, setSuccessDlg] = useState(false);
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [dynamicDescription, setDynamicDescription] = useState("");

  // state de exportação
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);

  const columnsFilter = [
    { name: "Sala", value: "sala", type: "text" },
    { name: "Atividade", value: "atividade", type: "text" },
    { name: "Data e Hora Inicio", value: "dataInicio", type: "date" },
    { name: "Data e Hora Fim", value: "dataFim", type: "date" },
    { name: "Quantidade Máxima", value: "quantidadeMax", type: "text" },
    { name: "Tipo", value: "tipo", type: "text" },
  ];

  // atualiza o filtro ativo e limpa a busca
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // inverte a data de dd/mm/yyyy para o formato aceito pela API (yyyy-mm-dd)
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  // aplica o tratamento de busca conforme o tipo da coluna filtrada (data ou texto)
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  // busca as atividades de estoque paginadas
  const fetchStockActivities = async () => {
    setLoading(true);
    try {
      const activitiesData = await getStockActivities(
        idEvent,
        token,
        currentIndex > 0 ? currentIndex : 1,
        itemsPerPage,
        treatmentSearch(),
        activeFilter,
      );

      setActivities(activitiesData);
      setCountData(activitiesData.total);
    } catch (err) {
      console.error("Erro ao buscar atividades:", err);
      setError("Erro ao buscar atividades.");
      toast.error("Erro ao buscar atividades.");
    } finally {
      setLoading(false);
    }
  };

  // deleta o estoque (ou estoque e agendamentos) conforme o tipo escolhido
  async function confirmDeleteAll(type) {
    setLoadingDelete(true);
    try {
      const response = await deleteAll(idEvent, type);
      if (response.message === "deleted") {
        setDynamicTitle("Sucesso");
        setDynamicDescription("Atividades deletadas com sucesso");
        setErrorOnDeleteAll(false);
      } else {
        setDynamicTitle("Erro");
        setDynamicDescription("Ocorreu um erro ao deletar os Estoques");
        setErrorOnDeleteAll(true);
      }
      setSuccessDlg(true);
      fetchStockActivities();
    } catch (error) {
      console.error("Erro ao deletar os estoques:", error);
      setDynamicTitle("Erro");
      setDynamicDescription("Erro ao deletar os estoques.");
      setErrorOnDeleteAll(true);
      setSuccessDlg(true);
    } finally {
      setLoadingDelete(false);
      setConfirmAllDisabled(false);
    }
  }

  useEffect(() => {
    fetchStockActivities();
  }, [
    idEvent,
    token,
    debouncedSearch,
    currentIndex,
    itemsPerPage,
    activeFilter,
  ]);

  return (
    <>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Estoque"
          onConfirm={() => setConfirmAllDisabled(true)}
        />
      )}

      {modalNewStock && (
        <ModalNewStock
          isOpen={modalNewStock}
          toggle={() => setModalNewStock(false)}
          idEvent={idEvent}
          jwt={token}
          refetch={fetchStockActivities}
        />
      )}

      {modalEditStock && (
        <ModalEditStock
          isOpen={modalEditStock}
          toggle={() => setModalEditStock(false)}
          data={activitiesEdit}
          jwt={token}
          refetch={fetchStockActivities}
          idEvent={idEvent}
        />
      )}

      {modalConfig && (
        <ModalConfig
          isOpen={modalConfig}
          toggle={() => setModalConfig(!modalConfig)}
          idEvent={idEvent}
          jwt={token}
        />
      )}

      {modalLink && (
        <ModalLinksEmbeded
          isOpen={modalLink}
          toggle={() => setModalLink(false)}
          eventId={idEvent}
        />
      )}

      {confirmDelete && (
        <SweetAlert
          title="Deseja deletar essa atividade?"
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={async () => {
            try {
              await deleteStockActivity(activitiesEdit.id, token);
              await fetchStockActivities();
              setConfirmDelete(false);
              setShowSuccessAlert(true);
            } catch (error) {
              console.error("Erro ao deletar a atividade:", error);
              setConfirmDelete(false);
              setShowDeleteErrorAlert(true);
            }
          }}
          onCancel={() => setConfirmDelete(false)}
        >
          Você não poderá reverter essa ação.
        </SweetAlert>
      )}
      {showDeleteErrorAlert && (
        <SweetAlert
          title="Erro"
          danger
          onConfirm={() => setShowDeleteErrorAlert(false)}
        >
          Erro ao deletar a atividade.
        </SweetAlert>
      )}
      {successDlg ? (
        <SweetAlert
          success={!errorOnDeleteAll}
          error={errorOnDeleteAll}
          title={dynamicTitle}
          onConfirm={() => {
            setSuccessDlg(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <>
            <p>{dynamicDescription}</p>
          </>
        </SweetAlert>
      ) : null}

      {confirmAllDisabled ? (
        <SweetAlert
          title={`Como deseja remover o estoque ?`}
          warning
          showCancel={!loadingDelete}
          showConfirm={false}
          confirmBtnText="Sim"
          cancelBtnText="Cancelar"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          cancelBtnCssClass="stock-cancel-btn"
          onCancel={() => setConfirmAllDisabled(false)}
        >
          {loadingDelete && (
            <div className="stock-delete-all-loading">
              <Spinner
                className="stock-delete-all-spinner"
                animation="border"
                size="lg"
              />
              <p>Limpando Estoques...</p>
            </div>
          )}
          {!loadingDelete && (
            <div className="stock-delete-all-options">
              <button
                className="btn btn-success stock-delete-all-btn"
                onClick={() => confirmDeleteAll("estoque")}
              >
                Somente Estoque
              </button>
              <button
                className="btn btn-success stock-delete-all-btn"
                onClick={() => confirmDeleteAll("all")}
              >
                Estoque e Agendamentos
              </button>
            </div>
          )}
        </SweetAlert>
      ) : null}

      {showSuccessAlert && (
        <SweetAlert
          title="Sucesso"
          success
          onConfirm={() => setShowSuccessAlert(false)}
        >
          Atividade deletada com sucesso
        </SweetAlert>
      )}

      {modalImport && (
        <ModalAllImports
          isOpen={modalImport}
          toggle={() => setModalImport(false)}
          idEvent={idEvent}
          refetch={fetchStockActivities}
          jwt={token}
        />
      )}

      <WaitExport
        isOpen={exportInProgress}
        name="Estoque"
        preposicao="do"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />

      <Card>
        <CardBody>
          <CardTitle>Estoque</CardTitle>

          <div className="stock-top-actions">
            <Button
              color="success"
              className="btn-rounded waves-effect waves-light events-button-add"
              onClick={() => setModalLink(true)}
            >
              Links Para Embedar
            </Button>

            <Button
              color="warning"
              className="btn-rounded waves-effect waves-light events-button-add stock-config-btn"
              onClick={() => setModalConfig(true)}
            >
              <i className="dripicons-gear" />
              Configurações
            </Button>
          </div>

          <Row className="stock-filter-toggle-row">
            <SectionComponent
              sectionName="Filtros"
              setIsOpen={setCollapseIsOpen}
              isOpen={collapseIsOpen}
            />
          </Row>
          <Collapse isOpen={collapseIsOpen}>
            <SearchFilters
              columns={columnsFilter}
              activeFilter={activeFilter}
              setActiveFilterHandle={setActiveFilterHandle}
            />
          </Collapse>

          <div className="stock-search-actions-row">
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  type={
                    activeFilter === "dataInicio" || activeFilter === "dataFim"
                      ? "date"
                      : "text"
                  }
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section">
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      value={search}
                      type={
                        activeFilter === "dataInicio" ||
                        activeFilter === "dataFim"
                          ? "date"
                          : "text"
                      }
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
            </div>

            <div className="header-btns-container">
              {activities?.data?.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add-lg"
                  onClick={() => {
                    createStockXlsx({
                      eventId: idEvent,
                      token,
                      limit: 100,
                      countData,
                      search,
                      columnSearch: activeFilter,
                      setFinishExport,
                    });
                    setExportInProgress(true);
                  }}
                >
                  Exportar Relatório
                </Button>
              )}

              <ActionButtonRounded
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                title="Importar Estoque"
                onClick={() => setModalImport(true)}
                margin={"0 5px"}
              />

              <ActionButtonRounded
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                title="Adicionar Estoque"
                onClick={() => setModalNewStock(true)}
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="thead-light">
                <tr>
                  <th>Sala</th>
                  <th>Atividade</th>
                  <th>Data e Hora Inicio</th>
                  <th>Data e Hora Fim</th>
                  <th>Quantidade Máxima</th>
                  <th>Quantidade Utilizada</th>
                  <th>Tipo</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={itemsPerPage} cols={8} />
                ) : error ? (
                  <tr>
                    <td colSpan="8">Erro: {error}</td>
                  </tr>
                ) : (
                  activities?.data?.map((activity) => (
                    <tr key={activity.id}>
                      <td>{activity.sala}</td>
                      <td>{activity.atividade}</td>
                      <td>
                        {moment
                          .utc(activity.dataHoraInicio)
                          .format("DD/MM/YYYY, HH:mm")
                          .replace(",", "")}
                      </td>
                      <td>
                        {moment
                          .utc(activity.dataHoraFim)
                          .format("DD/MM/YYYY, HH:mm")
                          .replace(",", "")}
                      </td>
                      <td>{activity.quantidadeMax}</td>
                      <td>{activity.quantidadeUtilizada}</td>
                      <td>{activity?.tipo}</td>
                      <td>
                        <i
                          className="mdi mdi-pencil action-icon-edit"
                          style={{ color: 'green' }}
                          onClick={() => {
                            setActivitiesEdit(activity);
                            setModalEditStock(true);
                          }}
                        />
                        <DeleteButton
                          onClick={async () => {
                            setActivitiesEdit(activity);
                            setConfirmDelete(true);
                          }}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            activities?.data?.length > 0 && showDeleteAll
              ? "space-between"
              : "end"
          }`,
        }}
      >
        {activities?.data?.length > 0 && (
          <ActionButtonRounded
            onClick={() => setModalDeleteAll(true)}
            title="Limpar Todos Estoques"
            action="D"
            color="danger"
            setShow={setShowDeleteAll}
            verifyShow={true}
          />
        )}

        <Pagination
          data={activities.data}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Stock);
